import Swiper from "swiper";
import 'swiper/css'

export default class SuccessStoriesSwiper {
    constructor() {
        const wrapper = document.querySelectorAll('.success-stories__widget-wrapper');

        if (!wrapper.length) {
            return;
        }
        
        wrapper.forEach((wrap) => {
            const storySwiper = new Swiper('.success-stories__swiper', {
                slidesPerView: 1,
                spaceBetween: 30,
                grabCursor: true,
            })
        });

        const categoryButtons = document.querySelectorAll('.success-stories__category-wrapper p');
        const storySlides = document.querySelectorAll('.single-success-story__wrapper');


        const closeAll = () => {
            categoryButtons.forEach(button => {
                button.classList.remove('is-active');
            })
        }

        categoryButtons.forEach(button => {
            button.addEventListener('click', () => {
                const selectedCategory = button.getAttribute('data-category');
                closeAll();
                button.classList.add('is-active');
                storySlides.forEach(slide => {
                    const categories = slide.getAttribute('data-category') || '';

                    if (selectedCategory === 'all' || categories.includes(selectedCategory)) {
                        slide.style.display = '';
                    } else {
                        slide.style.display = 'none';
                    }
                });
            });
        });
    }
}